<template>
  <div class="product-page">
    <!-- Banner Carousel -->
    <div
      id="productBannerCarousel"
      class="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="5000"
    >
      <div class="carousel-indicators">
        <button
          v-for="(b, i) in banners"
          :key="`banner-ind-${i}`"
          type="button"
          data-bs-target="#productBannerCarousel"
          :data-bs-slide-to="i"
          :class="{ active: i === 0 }"
          :aria-current="i === 0 ? 'true' : 'false'"
          :aria-label="`Slide ${i + 1}`"
        ></button>
      </div>

      <div class="carousel-inner">
        <div
          v-for="(b, i) in banners"
          :key="`banner-${i}`"
          class="carousel-item"
          :class="{ active: i === 0 }"
        >
          <a v-if="b.link" :href="b.link" target="_blank" rel="noopener">
            <img :src="b.src" class="d-block w-100 banner-img" :alt="b.alt" />
          </a>
          <img v-else :src="b.src" class="d-block w-100 banner-img" :alt="b.alt" />
        </div>
      </div>

      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#productBannerCarousel"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>

      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#productBannerCarousel"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

    <!-- Product Cards -->
    <div class="container-sm py-5 product-cards-wrap">
      <div
        v-for="(p, idx) in products"
        :key="p.key"
        class="product-card card shadow-sm mb-4 product-card-clickable"
        role="link"
        tabindex="0"
        :aria-label="`Open ${p.key}`"
        @click="openProduct(p.link)"
        @keydown.enter.prevent="openProduct(p.link)"
        @keydown.space.prevent="openProduct(p.link)"
      >
        <div class="card-body p-0">
          <div class="row g-0 align-items-stretch">
            <!-- Image -->
            <div class="col-12 col-md-4">
              <div class="img-wrap">
                <img :src="p.img" class="product-img" :alt="p.key" />
              </div>
            </div>

            <!-- Text -->
            <div class="col-12 col-md-8">
              <div
                class="product-text p-4 p-md-5 h-100 d-flex flex-column justify-content-center"
              >
                <div class="product-title" v-html="$t(`AllProducts.${p.key}-title`)"></div>

                <div
                  v-if="hasI18n(`AllProducts.${p.key}-desc`)"
                  class="product-desc mt-2"
                >
                  {{ $t(`AllProducts.${p.key}-desc`) }}
                </div>

                <!-- ✅ 保留 VIEW ALL 連結，但避免觸發外層 click（不然會開兩次） -->
                <a
                  class="view-all mt-3"
                  :href="p.link"
                  target="_blank"
                  rel="noopener"
                  @click.stop
                >
                  VIEW ALL &gt;&gt;
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- subtle separator vibe (optional) -->
        <div v-if="idx < products.length - 1" class="divider"></div>
      </div>
    </div>
  </div>
</template>

<script>
import banner00 from "@/assets/images/Product/myguard_pro_banner_00.jpg";
import banner01 from "@/assets/images/Product/myguard_pro_banner_01.jpg";
import banner02 from "@/assets/images/Product/myguard_pro_banner_02.jpg";
import banner03 from "@/assets/images/Product/myguard_pro_banner_03.jpg";

import pro01 from "@/assets/images/Product/myguard_pro_01.png";
import pro02 from "@/assets/images/Product/myguard_pro_02.png";
import pro03 from "@/assets/images/Product/myguard_pro_03.png";
import pro04 from "@/assets/images/Product/myguard_pro_04.png";

export default {
  name: "ProductPage",
  data() {
    return {
      headerOffset: 0,
      banners: [
        { src: banner02, alt: "STERiJECT", link: "https://tsklab.com.tw/product/STERiJECT" },
        { src: banner03, alt: "STERiGLIDE", link: "https://tsklab.com.tw/product/STERiGLIDE" },
        { src: banner01, alt: "TSN", link: "https://tsklab.com.tw/product/TskSelectNeedle" },
        { src: banner00, alt: "TSY", link: "https://tsklab.com.tw/product/TSKSyringe" },
      ],
      products: [
        {
          key: "TSN",
          img: pro01,
          link: "https://tsklab.com.tw/product/TskSelectNeedle",
        },
        {
          key: "STERiGLIDE",
          img: pro03,
          link: "https://tsklab.com.tw/product/STERiGLIDE",
        },
        {
          key: "STERiJECT",
          img: pro02,
          link: "https://tsklab.com.tw/product/STERiJECT",
        },
        {
          key: "TSY",
          img: pro04,
          link: "https://tsklab.com.tw/product/TSKSyringe",
        },
      ],
    };
  },
  mounted() {
    this.updateHeaderOffset();
    window.addEventListener("resize", this.updateHeaderOffset);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateHeaderOffset);
  },
  methods: {
    hasI18n(path) {
      return typeof this.$i18n?.te === "function" ? this.$i18n.te(path) : true;
    },
    updateHeaderOffset() {
      const navbar = document.getElementById("navbar");
      this.headerOffset = navbar ? navbar.offsetHeight : 0;
    },

    // ✅ 整張卡片點擊行為（最穩）
    openProduct(url) {
      if (!url) return;
      window.open(url, "_blank", "noopener");
    },
  },
};
</script>

<style lang="scss" scoped>
.product-page {
  background: #fff;
}

/* Banner Carousel */
#productBannerCarousel {
  position: relative;
}

.banner-img {
  width: 100%;
  height: clamp(240px, 40vw, 520px);
  object-fit: contain;
  object-position: center center;
  background: #fff;
}

#productBannerCarousel .carousel-control-prev,
#productBannerCarousel .carousel-control-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 56px;
  z-index: 2;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

#productBannerCarousel .carousel-control-prev:hover,
#productBannerCarousel .carousel-control-next:hover {
  opacity: 1;
}

#productBannerCarousel .carousel-control-prev {
  left: 12px;
}

#productBannerCarousel .carousel-control-next {
  right: 12px;
}

#productBannerCarousel .carousel-control-prev-icon,
#productBannerCarousel .carousel-control-next-icon {
  width: 22px;
  height: 22px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  padding: 0;
  box-shadow: none;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.45));
}

/* Product Cards */
.product-card {
  border-radius: 12px;
  overflow: hidden;
}

/* ✅ 整張卡可點：游標、hover、focus */
.product-card-clickable {
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.15s ease;
}

.product-card-clickable:hover {
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.18);
  transform: translateY(-1px);
}

.product-card-clickable:focus-visible {
  outline: 3px solid rgba(80, 167, 223, 0.35);
  outline-offset: 3px;
}

.img-wrap {
  height: 100%;
  min-height: 220px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 18px;
}

.product-text {
  text-align: left;
  align-items: flex-start;
}

.product-title {
  font-weight: 800;
  font-size: 1.15rem;
  line-height: 1.35;
}

.product-desc {
  color: #444;
  font-size: 0.95rem;
}

.view-all {
  font-weight: 700;
  text-decoration: none;
  align-self: flex-start;
}

.view-all:hover {
  text-decoration: underline;
}

.divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.06);
}

.product-cards-wrap {
  width: 100%;
}

@media (min-width: 1200px) {
  .product-cards-wrap {
    max-width: 60vw;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
